import { useEffect, useState } from "react";
import { Button, IconButton, Skeleton } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { BreadcrumbsWidget, DataTableWrap } from "components";
import { useParams } from "react-router-dom";
import { useDeleteCategoryMutation } from "redux/api/slices/server";
import { useKategoriAramaMutation } from "api/search";
import { useResponseAll, useResponseErrorOnly } from "hooks";
import SearchBar from "./SearchBar";

const CategoriesPage = () => {
  const { id } = useParams();
  const Id = parseInt(id);
  const [KategoriArama, search] = useKategoriAramaMutation();
  const [deleteCategory, deleteReq] = useDeleteCategoryMutation();
  const [activeItem, setActiveItem] = useState("Kategoriler");

  const columns = [
    {
      name: "ID",
      selector: (row) => row.id,
      sortable: true,
      width: "100px",
    },
    {
      name: "Kategori",
      selector: (row) => row.title,
      cell: (row) => {
        return (
          <>
            {row.sub > 0 ? (
              <Button variant="text" href={`/categories/${row.id}`}>
                {row.title}
              </Button>
            ) : (
              <Button
                variant="text"
                color="secondary"
                href={`/categories/${row.parantId}`}
              >
                {row.title}
              </Button>
            )}
          </>
        );
      },
      sortable: true,
    },
    {
      name: "Üst Kategori",
      cell: (row) => {
        return <span>{row.parantcategory.title ?? "Üst Kategori Yok"}</span>;
      },
      sortable: true,
    },
    {
      right: true,
      width: "10px",
      cell: (row) => {
        return (
          <IconButton
            aria-label="detaitl"
            size="small"
            href={`/detail-category/${row.id}`}
          >
            <Edit fontSize="inherit" />
          </IconButton>
        );
      },
    },
  ];

  useEffect(() => {
    if (Id === 0) {
      KategoriArama();
    } else {
      KategoriArama({ ust_id: Id });
    }
  }, [KategoriArama, Id]);

  useEffect(() => {
    if (Id > 0) {
      if (search.isSuccess) {
        const activeCat = search.data.find((x) => x.parantcategory.id === Id);
        setActiveItem(activeCat.parantcategory.title ?? false);
      }
    }
  }, [search, Id]);

  useResponseErrorOnly(search);
  useResponseAll(deleteReq);

  return (
    <div className="w-full my-6">
      <div className="w-full h-auto container mx-auto">
        {search.isLoading ? (
          <Skeleton height={340} />
        ) : (
          <>
            <div className="w-full mb-6">
              <BreadcrumbsWidget
                data={
                  Id !== 0 ? [{ title: "Kategoriler", url: `/categories/0` }] : false
                }
                activeItem={activeItem}
              />
              <SearchBar Arama={KategoriArama} data={search} id={Id} />
            </div>
            <div className="w-full h-auto flex flex-col p-5 gap-4 border shadow bg-white">
              <div className="w-full h-auto block">
                <DataTableWrap
                  title="Kategoriler"
                  columns={columns}
                  initialData={search.data}
                  externalFunction={deleteCategory}
                />
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default CategoriesPage;
